import createAction from '../../services/create-action';
export const SET_APP_CONFIG = 'app-config/SET';
export const setAppConfig = createAction(SET_APP_CONFIG);
//# sourceMappingURL=app-config-actions.js.map